export const appUrlPaths = {
  bzh: 'bzh',
  ja: 'ja',
  it: 'it',
  de: 'de',
};

